// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>

<div class="secondary" style="position:absolute; width: 100%; height: 100%;">
  <v-container style="width: 100%; height: 100%;">
    <v-layout column align-center style="width: 100%; height: 100%;">
      <div class="text-h2" style="padding-top: 10%; display: flex; align-items: center; font-family: Regular">
        <img src="@/assets/images/sr_logo.svg" width="92" height="92" alt="Star Registration Logo"/>
        <span><strong style="font-family: Proxima_Bold">STAR</strong><span class="h-small-span">REGISTRATION</span></span>
      </div>
      <div v-if="$store.state.wasmSupport" style="margin: auto;">
        <div style="display:flex; justify-content: center;">
          <p class="grey--text"><i18n path="Loading {0} Star Finder"><span>StarRegistration</span></i18n></p>
        </div>
        <div style="display:flex; justify-content: center;">
          <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7"  class="grey--text"/>
        </div>
      </div>
      <v-card v-else style="margin: auto;">
        <v-card-title primary-title>
          <div class="text-h5"><h1>{{ $t('Could not show the Online Star Map') }}</h1></div>
          <div class="text-h5" style="margin-top: 30px"><v-icon large>error</v-icon> {{ $t('It seems that your browser cannot load Web Assembly!') }}</div>
        </v-card-title>
        <v-card-text>
          <v-layout column align-center style="width: 100%; height: 100%;">
            <p class="grey--text">{{ $t('Web assembly is necessary for Star Registration Web to display the star map. Please upgrade your web browser and try again!') }}</p>
<!--            <p><i18n path="In the meantime, you can try the {0}!"><a href="https://stellarium.org">{{ $t('desktop version') }}</a></i18n></p>-->
          </v-layout>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</div>

</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .text-h2{
    @media screen and (max-width: 599px){
      font-size: 36px !important;
    }
    @media screen and (max-width: 400px){
      font-size: 28px !important;
    }
    .h-small-span{
      @media screen and (max-width: 599px){
        font-size: 34px !important;
      }
      @media screen and (max-width: 400px){
        font-size: 26px !important;
      }
      @media screen and (min-width: 600px){
        font-size: 48px !important;
      }
    }
    img{
      width: 50px;
      margin-right: 15px;
      @media screen and (max-width: 400px){
        width: 35px;
        margin-right: 10px;
      }
    }
  }
  .v-application .secondary{
    background-color: #101420 !important;
    border-color: #101420 !important;
  }
</style>
